export const COOKIE_REVISION_KEY = 'revision';
export const ASSET_BETA = 'beta';
export const ASSET_PRODUCTION = 'current';
export const PUBLIC_ASSET_REVISIONS = [ASSET_BETA, ASSET_PRODUCTION];
